import { isDesktopSamlCallback } from './desktopSamlHandoff';

export const parseQueryString = queryString => {
  const data = {};
  let pair;
  let separatorIndex;
  let escapedKey;
  let escapedValue;
  let key;
  let i;
  let value;

  if (queryString === null) {
    return data;
  }

  const pairs = queryString.split('&');

  for (i = 0; i < pairs.length; i += 1) {
    pair = pairs[i];
    separatorIndex = pair.indexOf('=');

    if (separatorIndex === -1) {
      escapedKey = pair;
      escapedValue = null;
    } else {
      escapedKey = pair.substr(0, separatorIndex);
      escapedValue = pair.substr(separatorIndex + 1);
    }

    key = decodeURIComponent(escapedKey);
    value = decodeURIComponent(escapedValue);

    data[key] = value;
  }

  return data;
};

export const getFragment = () => {
  if (window.location.hash.indexOf('#') === 0) {
    return parseQueryString(window.location.hash.substr(1));
  }
  return {};
};

export const getUrlParameter = (location, param) => {
  const name = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

// Provider callback routes render a transient "please wait, redirecting"
// screen. The external API consent/resume routes are interactive and must
// retain analytics/support/widget bootstrap.
export const isOAuthCallbackRoute = () =>
  typeof window !== 'undefined' &&
  (isDesktopSamlCallback() ||
    (window.location.pathname.startsWith('/oauth/') &&
      !['/oauth/external-api/consent', '/oauth/external-api/resume'].includes(
        window.location.pathname
      )));
